export const ROUTES = {
    LOGIN: "/login",
    PROFILE: "/profile",
    DEBUG: "/debug",
    HOME: '/',
    PROVISION: '/provision',
    OPERATE_MACHINE: '/operate-machine',
    MACHINES: '/machines',
    MACHINES_REPORT: '/machines/report',
};
